module.exports = __webpack_public_path__ + "img/unbarring.a8f99902.jpg";